import { Check, LockKeyhole, MoveRight } from "lucide-react";
import { PageHeading } from "../components/PageHeading";
import { StatusBadge } from "../components/StatusBadge";
import { usePortal } from "../context/PortalContext";

const PATH_LABELS = { completed: "已完成", current: "当前阶段", next: "下一阶段", locked: "后续阶段" };

export function PlanPage() {
  const { track } = usePortal();
  if (!track) return <div className="loading-state">正在读取学习规划</div>;
  return (
    <>
      <PageHeading number="03" title="学习规划" description={`预计还需要 ${track.curriculum.total_estimated_hours[0]}–${track.curriculum.total_estimated_hours[1]} 小时有效学习与练习；阶段按证据过关，不按时间自动升级。`} />
      <div className="stage-spine">
        {track.curriculum.stages.map((stage) => (
          <article className={`stage-row stage-${stage.path_status}`} key={stage.id}>
            <div className="stage-folio">{String(stage.number).padStart(2, "0")}</div>
            <div className="stage-main">
              <div className="stage-title-line"><div><span>{PATH_LABELS[stage.path_status]}</span><h2>{stage.title}</h2></div><strong>{stage.hours[1] ? `${stage.hours[0]}–${stage.hours[1]} 小时` : "已建立"}</strong></div>
              <p className="stage-growth">{stage.growth}</p>
              <div className="stage-columns">
                <div><h3>学习目标</h3><ul>{stage.objectives.map((item) => <li key={item}>{item}</li>)}</ul></div>
                <div><h3>怎么学</h3><ul>{stage.methods.map((item) => <li key={item}>{item}</li>)}</ul></div>
                <div><h3>检验门槛</h3><ul>{stage.gates.map((item) => <li key={item}>{item}</li>)}</ul></div>
              </div>
              <div className="stage-evidence">
                {stage.evidence_status.competencies.length ? stage.evidence_status.competencies.map((item) => <span key={item.id}>{item.name}<StatusBadge status={item.status} /></span>) : <span><Check size={15} />资料与基线已验证</span>}
              </div>
            </div>
            <div className="stage-path-icon">{stage.path_status === "completed" ? <Check size={20} /> : stage.path_status === "locked" ? <LockKeyhole size={18} /> : <MoveRight size={20} />}</div>
          </article>
        ))}
      </div>
    </>
  );
}
